import { UserRoleType } from '../../user/constants/teacher-roles.constants';

export class UserToAdd {
  constructor(
    public firstName = '',
    public lastName = '',
    public email = '',
    public password = '',
    public confirmPassword = '',
    public active = true,
    public setGroups: string[] = [],
    public selectedRole: UserRoleType = UserRoleType.TEACHER
  ) {}

  checkPasswordConfirm(): boolean {
    return this.password === this.confirmPassword;
  }

  /**
   * Clear all data in the object.
   */
  clear(): void {
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.password = '';
    this.confirmPassword = '';
    this.setGroups = [];
    this.selectedRole = UserRoleType.TEACHER;
  }

  generateRandomPassword(length = 10): void {
    this.password = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
      this.password += characters.charAt(Math.floor(Math.random() * characters.length));
    }
  }
}

export class UserToAddAlreadyExisted {
  public constructor(public userAlreadyExisted = false, public passwordGenerated = '') {}
}
